export class PinnedReport {
   id: number;
   name: string;
}
